var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.586 4l-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293v3.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.003 0-0.005 0-0.008-0.001-0.132-0.028-0.258-0.075-0.374-0.101-0.245-0.297-0.441-0.543-0.543-0.115-0.047-0.241-0.074-0.373-0.075-0.003 0-0.006 0-0.009 0h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1zM5.414 20l5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293v-3.586c0-0.552-0.448-1-1-1s-1 0.448-1 1v6c0 0.003 0 0.006 0 0.009 0.001 0.132 0.028 0.258 0.075 0.373 0.101 0.245 0.297 0.441 0.543 0.543 0.115 0.047 0.242 0.074 0.374 0.075 0.003 0 0.005 0 0.008 0h6c0.552 0 1-0.448 1-1s-0.448-1-1-1z"}));
}

Expand.defaultProps = {"id":"icon-expand","viewBox":"0 0 23 17"};

module.exports = Expand;

Expand.default = Expand;
